module.exports = __webpack_public_path__ + "static/media/24UHCHR7.2cba4f3d.jpg";